import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { LoadingButton, LoadingButtonProps } from '@mui/lab';
import {
  Box,
  Button,
  ButtonProps,
  FormControl,
  Stack,
  SxProps,
  TextFieldProps,
  Typography,
} from '@mui/material';

import { useNavigate } from 'react-router';
import { userForgotPassword } from '../../store/AuthSlice/V2/AuthApi';
import { getAuthState } from '../../store/AuthSlice';
import { TP_COLORS } from '../../constants';
import { useAppSelector } from '../../hooks';
import { TPTextField } from '../../components/Inputs';
import Header from '../V2/Portal/components/Header';

const boxStyles: SxProps = {
  minHeight: 'calc(100vh - 64px)',
  marginTop: '64px',
  background: `url(${process.env.PUBLIC_URL}/images/backgrounds/bg-reset-password.avif)`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const stackStyles: SxProps = {
  textAlign: 'center',
  padding: 4,
  maxWidth: 350,
  width: '100%',
};

const loadingButtonProps: LoadingButtonProps = {
  fullWidth: true,
  disableElevation: true,
  variant: 'contained',
  sx: {
    py: '13px',
    borderRadius: '35px',
    fontSize: '16px',
    fontWeight: '600',
    backgroundColor: TP_COLORS.gray.darken,
    '&:hover': {
      backgroundColor: '#11172b',
    },
  },
};

const backButtonProps: ButtonProps = {
  fullWidth: true,
  variant: 'text',
  sx: {
    py: '13px',
    borderRadius: '35px',
    fontSize: '16px',
    fontWeight: '600',
    color: TP_COLORS.gray.darken,
  },
};

const textFieldProps: TextFieldProps = {
  sx: {
    '& .MuiInputBase-root': {
      height: '52px',
    },
  },
};

const ForgotPassword: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Store
  const { status } = useAppSelector(getAuthState);

  // State
  const [email, setEmail] = useState<string>('');

  const isSubmitDisabled = email.length < 3;

  const onSendCode = () => {
    if (email) {
      dispatch(
        userForgotPassword({
          email: email.toLowerCase(),
        })
      );
    }
  };

  return (
    <Box>
      <Header />
      <Box sx={boxStyles}>
        <Stack spacing={4} sx={stackStyles}>
          <Stack spacing="10px">
            <Typography fontSize="30px" fontWeight="700" lineHeight="36px">
              Forgot Password ?
            </Typography>
            <Typography fontSize="14px" color="#647488" lineHeight="17px">
              Enter your email address for instructions
            </Typography>
          </Stack>

          <FormControl fullWidth>
            <TPTextField
              {...textFieldProps}
              name="email"
              label="Email Address"
              value={email}
              onChange={(e) => setEmail(e.currentTarget.value)}
            />
          </FormControl>

          <Stack spacing={1}>
            <LoadingButton
              {...loadingButtonProps}
              loading={status === 'loading'}
              disabled={isSubmitDisabled}
              onClick={onSendCode}
            >
              SEND CODE
            </LoadingButton>

            <Button
              {...backButtonProps}
              onClick={() => navigate(`${process.env.PUBLIC_URL}/login`)}
            >
              Back to Sign In
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
};

export default ForgotPassword;
